"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CHAT_MEMBERS_FILTER;
(function (CHAT_MEMBERS_FILTER) {
    CHAT_MEMBERS_FILTER["chatMembersFilterContacts"] = "chatMembersFilterContacts";
    CHAT_MEMBERS_FILTER["chatMembersFilterAdministrators"] = "chatMembersFilterAdministrators";
    CHAT_MEMBERS_FILTER["chatMembersFilterMembers"] = "chatMembersFilterMembers";
    CHAT_MEMBERS_FILTER["chatMembersFilterRestricted"] = "chatMembersFilterRestricted";
    CHAT_MEMBERS_FILTER["chatMembersFilterBanned"] = "chatMembersFilterBanned";
    CHAT_MEMBERS_FILTER["chatMembersFilterBots"] = "chatMembersFilterBots";
})(CHAT_MEMBERS_FILTER = exports.CHAT_MEMBERS_FILTER || (exports.CHAT_MEMBERS_FILTER = {}));
